import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getBudgetsData = params =>
  axios.get(`${API_HOST}/shashoku-budgets`, { params, withCredentials: true });

export const updateBudgetsStatusData = params =>
  axios.post(`${API_HOST}/shashoku-budgets/confirm`, params, {
    withCredentials: true
  });

export const editBudgetData = (budgetId, budgetAmount) =>
  axios.put(
    `${API_HOST}/shashoku-budgets/${budgetId}`,
    { budgetAmount },
    {
      withCredentials: true
    }
  );

export const getConnectSystemUrlData = params =>
  axios.get(`${API_HOST}/shashoku-budgets/${params}`, {
    withCredentials: true
  });

export const sendBudgetEmailData = params =>
  axios.post(`${API_HOST}/shashoku-budgets/send-email-budget`, params, {
    withCredentials: true
  });

export const addShashokuData = params =>
  axios.post(`${API_HOST}/shashoku-budgets/release-system`, params, {
    withCredentials: true
  });

export const getGroupBudgetsData = params =>
  axios.get(`${API_HOST}/budget`, { params, withCredentials: true });

export const postGroupBudgetData = params =>
  axios.post(`${API_HOST}/budget`, params, { withCredentials: true });

export const putGroupBudgetData = params =>
  axios.put(`${API_HOST}/budget`, params, { withCredentials: true });

export const confirmBudget = params =>
  axios.put(`${API_HOST}/budget/confirm`, params, {
    withCredentials: true
  });

export const getTicketsGochiData = params =>
  axios.get(`${API_HOST}/budget/gochi`, { params, withCredentials: true });

export const downloadTicketsGroupData = params =>
  axios.get(`${API_HOST}/budget/gochi/download`, {
    params,
    withCredentials: true
  });

export const toggleUseReceiptData = (params, connectSystemId) =>
  axios.put(
    `${API_HOST}/shashoku-budgets/ocr-enable/${connectSystemId}`,
    params,
    {
      withCredentials: true
    }
  );

export const combiniAddShopData = params =>
  axios.post(`${API_HOST}/shashoku-budgets/bizmeshi-shop`, params, {
    withCredentials: true
  });

export const combiniEditShopData = (shopId, params) =>
  axios.put(`${API_HOST}/shashoku-budgets/bizmeshi-shop/${shopId}`, params, {
    withCredentials: true
  });

export const changeAllowDToFData = (systemId, params) =>
  axios.put(`${API_HOST}/shashoku-budgets/allow-d-to-f/${systemId}`, params, {
    withCredentials: true
  });
export default getBudgetsData;

export const toggleLalapayEnableData = (params, connectSystemId) =>
  axios.put(
    `${API_HOST}/shashoku-budgets/lalapay-enable/${connectSystemId}`,
    params,
    {
      withCredentials: true
    }
  );
